var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeaknesses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.54,
    height: 24.5,
    viewBox: "0 0 24.54 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 24.54,
    height: 24.5,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M2.41,8.863H6.15a.826.826,0,1,0,0-1.653H2.41a.826.826,0,1,0,0,1.653",
    transform: "translate(0.51 2.323)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M7.915,9.054a.824.824,0,0,0,.578.237H8.5a.826.826,0,0,0,.582-1.406L4.41,3.212A.826.826,0,1,0,3.241,4.38Z",
    transform: "translate(0.966 0.956)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M8.066,6.946a.827.827,0,0,0,.826-.826V2.38a.826.826,0,1,0-1.653,0V6.12a.828.828,0,0,0,.826.826m0-.165Z",
    transform: "translate(2.333 0.5)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M12.183,10.986h0a.818.818,0,0,0-.578-.235H11.6a.816.816,0,0,0-.58.247.829.829,0,0,0,0,1.158l4.677,4.676a.826.826,0,0,0,1.168-1.169Z",
    transform: "translate(3.474 3.464)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M20.351,1.362l0,0a4.895,4.895,0,0,0-6.774,0l-3.9,3.9A3.478,3.478,0,0,0,8.654,7.716v2.643a.826.826,0,1,0,1.653,0V7.716A1.816,1.816,0,0,1,10.84,6.43l3.9-3.9a3.209,3.209,0,0,1,4.443,0,3.143,3.143,0,0,1,0,4.44l-3.9,3.9a1.823,1.823,0,0,1-1.288.533H11.349a.826.826,0,1,0,0,1.653H14a3.474,3.474,0,0,0,2.446-1.017l3.9-3.9a4.8,4.8,0,0,0,0-6.778",
    transform: "translate(2.789 -0.001)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M17.464,10.04H13.724a.826.826,0,0,0,0,1.653h3.739a.826.826,0,1,0,0-1.653",
    transform: "translate(4.157 3.235)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M10.9,12.867h-.042a.826.826,0,0,0-.784.825v3.739a.826.826,0,1,0,1.652,0V13.693a.808.808,0,0,0-.241-.583.818.818,0,0,0-.584-.243",
    transform: "translate(3.245 4.146)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M12.271,10.492a.827.827,0,0,0-.826.826v2.649a1.814,1.814,0,0,1-.533,1.283l-3.9,3.9a3.209,3.209,0,0,1-4.443,0A3.143,3.143,0,0,1,2.5,14.78l.02.008.049-.078,3.9-3.9a1.816,1.816,0,0,1,1.28-.532H10.4a.826.826,0,1,0,0-1.653H7.746A3.468,3.468,0,0,0,5.3,9.641l-3.9,3.9a4.793,4.793,0,0,0,6.778,6.778l3.9-3.9A3.48,3.48,0,0,0,13.1,13.966V11.318a.828.828,0,0,0-.826-.826m0,.165Z",
    transform: "translate(0 2.779)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaknesses);
export default __webpack_public_path__ + "static/media/weaknesses.ae7feb7f8806177d846ba32f8f5c05e4.svg";
export { ForwardRef as ReactComponent };